var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStop = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  rx: 2
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStop);
export default ForwardRef;